import type { FC } from 'react';
import { Grid, Paper, Typography } from '@mui/material';

export interface ITemplate {
  id: string;
  name: string;
  previewUrl: string;
  description?: string;
  duration?: number;
  category?: string;
}

interface ITemplateSelectionGridProps {
  templates: ITemplate[];
  selectedTemplateId: string | null;
  onTemplateSelect: (templateId: string) => void;
}
const TemplateSelectionGrid: FC<ITemplateSelectionGridProps> = ({
  templates,
  selectedTemplateId,
  onTemplateSelect,
}) => {
  return (
    <>
      <Typography variant="h6" sx={{ pl: 1 }}>
        Please Select Template
      </Typography>
      <Grid container spacing={2} sx={{ p: 1 }}>
        {templates?.map((template: any) => (
          <Grid item xs={12} sm={6} md={3} key={template.id}>
            <Paper
              sx={{
                cursor: 'pointer',
                p: 1,
                transition: 'border 0.2s',
                height: 250,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                border: selectedTemplateId === template.id ? '3px solid #000' : '1px solid #ccc',
              }}
              onClick={() => onTemplateSelect(template.id)}>
              <video
                width="100%"
                style={{
                  borderRadius: '5px',
                  marginBottom: 8,
                  objectFit: 'cover',
                  height: 350,
                }}
                height={350}
                controls
                src={template.previewUrl + '#t=0.1'}
              />
              <Typography variant="subtitle2" align="center" sx={{ fontSize: 14 }}>
                {template.name}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default TemplateSelectionGrid;
